import React, { Component } from "react";
import { Loader } from "semantic-ui-react";

import UserFollowCard from "../UserFollowCard";
import "./index.css";
import InfiniteScroll from "react-infinite-scroller";

class UsersList extends Component {
  state = { hasMore: true };
  constructor(props) {
    super(props);
    this.loadMoreUsers = this.loadMoreUsers.bind(this);
  }
  
  componentDidMount() {
    this.props.isSSRUser && this.props.loadMoreUsers({ override: true, pagingToken: null });
  }

  loadMoreUsers() {
    this.props.loadMoreUsers({});
  }
  render() {
    const { data: users = [], hasMore } = this.props.users;
    if (users.length === 0 && !hasMore) {
      return (
        <section className="connections-list-wrapper">
          <div>No users :( </div>
        </section>
      );
    }

    return (
      <section className="connections-list-wrapper">
        <InfiniteScroll
          loadMore={this.loadMoreUsers}
          hasMore={hasMore}
          loader={
            <div className="padded">
              <Loader size="large" active inline="centered" />
            </div>
          }
        >
          {users.map((user, index) => <UserFollowCard user={user} key={index} />)}
        </InfiniteScroll>
      </section>
    );
  }
}
export default UsersList;



// WEBPACK FOOTER //
// ./src/components/UsersList/index.js